<div class="row">
    <nav class="navbar navbar-fixed-top" role="navigation" style="margin-bottom: 0">
        <div class="navbar-header">
            <div class="page-title" (click)="toggleNavigation()">
                <h1>{{ app.appInfo.title }}</h1>
            </div>
            <div class="navbar-warning" *ngIf="app.appInfo.versionWarning">
                <i class="fa fa-warning ml-2" style="color: rgb(182, 0, 0)" title="{{app.appInfo.versionWarning}}"></i>
            </div>
        </div>
        <ul class="nav navbar-top-links navbar-right d-none d-sm-block">
            <li style="margin: 0px; margin-right: 15px;">
                <a [routerLink]="''" style="padding: 0;"> <img src="./assets/images/logo.png" style="width: 100%;" /> </a>
            </li>
        </ul>
    </nav>
</div>
